import {
  FONTS,
} from 'Reducers/ad/utils';
import { addStyleToSelectedComponents } from './styleActions';

export const setFont = (font, weight) => ({
  type: 'SET_FONT',
  font,
  weight,
});

export const setFontWithDefaultWeight = font => (dispatch, getState) => {
  const state = getState();
  const defaultWeight = state.getIn([FONTS, 'fontWeights']).get(font).first().id;
  dispatch(setFont(font, defaultWeight));
};

export const setWeight = weight => ({
  type: 'SET_WEIGHT',
  weight,
});

export const setWeightAndApplyStyle = weight => (dispatch) => {
  const fontWeight = (weight.name && !isNaN(weight.name)) ? weight.name : '';
  const fontStyle = (weight.name && weight.name.includes('italic')) ? 'italic' : '';
  if (weight === null) {
    dispatch(addStyleToSelectedComponents({ fontFamily: '' }));
    dispatch(setWeight(null));
  } else {
    dispatch(addStyleToSelectedComponents({ fontFamily: `"${weight.family}"`, fontWeight, fontStyle }));
    dispatch(setWeight(weight.id));
  }
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/actions/settingsActions.js